import React, { useEffect, useState } from "react";
import axios from "../../axios-backend";
import BackButton from "../main/BackButton";
import Text from "../main/Text";


const TheWonleys = () => {
  const [data, setData] = useState(null);

  const fetchContent = async () => {
    try {
      const response = await axios.get("/content");
      setData(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchContent();
  }, []);

  if (!data) return <div>Loading...</div>;

  return (
    <>
      <BackButton />
<Text style={{ whiteSpace: "pre-line" }}>
  {data.content}
</Text>    </>
  );
};

export default TheWonleys;